import Axios from "axios";
const baseURL = process.env.BARRAMUNDI;
const baseURLci = process.env.CI_APPS;

export default {
    applyDiscount(params) {
        return Axios.post(
            `${baseURL}billing/estimate/apply-discount`,
            params
        ).then(response => response.data.response);
    },
    removeDiscount(estimateId) {
        return Axios.post(`${baseURL}billing/estimate/remove-discount`, {
            id: estimateId
        }).then(response => response.data.response);
    }
};
